<div class="flex gap-2 justify-end px-6 py-4 border-t border-t-gray-100 -mx-6 -mb-6">
  <ng-content></ng-content>
</div>
